import axios from "axios";
import qs from "qs";

const instance = axios.create({
  //როდესაც ლოკალურად უშვებ აუცილებელია გამოიყენოს ქვემოთ რაც წერია
  //baseURL: `https://localhost:7039/api`,
  //როდესაც პროდაქშენზე უშვებ აუცილებელია გამოიყენო ქვემოთ რაც წერია
  baseURL: `/api`,
  timeout: 30000,
  withCredentials: true,
  paramsSerializer: function (params) {
    return qs.stringify(params, { arrayFormat: "repeat" });
  },
});

export default instance;
